// src/Home.js
import React, {
  useState,
  useEffect,
  Suspense
} from 'react';

import { useLocation } from 'react-router-dom';

import SEO from '../SEO/SEO';
import LoadingSpinner from '../loadingspinner/LoadingSpinner';

import {
  Navbar2,
  ImageSlider,
  Portofolio,
  FloatingWhatsApp,
  Footer,
  OurService,
} from '../LazyLoad/lazyComponents';

import RekanataContent from './components/rekanata/pages/RekanataContent';
import ClientsSection from '../clientssection/ClientsSection';
import FAQ from '../faq/FAQ';
import HeroCallAction from '../herosection/herocallaction/HeroCallAction';
import HeroFreeDesignMasjid from '../herosection/herofreedesign/HeroFreeDesignMasjid';

import EbooksApp from '../ebooks/EbooksApp';

function Home() {
  const location = useLocation();

  // State untuk loading awal konten (opsional, hanya UX)
  const [contentReady, setContentReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setContentReady(true);
      console.log('Konten utama Home siap.');
    }, 500); // Waktu loading simulasi

    return () => clearTimeout(timer);
  }, []);

  // Loading spinner awal saat konten belum siap
  if (!contentReady) {
    return <LoadingSpinner />;
  }

  return (
    <div className="home-container fade" id="id-home-container">
      {/* SEO Meta Tags */}
      <SEO
        title="Rekanata Konstruksi - Jasa Kontraktor Bangunan Profesional di Bandung & Seluruh Indonesia"
        description="Rekanata Konstruksi: jasa kontraktor profesional & amanah di Bandung, melayani pembangunan & renovasi rumah, kantor, ruko, masjid, bangunan komersial, serta desain interior & lanskap. Kualitas terjamin, layanan terbaik di seluruh Indonesia."
        canonical="https://rekanata.com/"
      />

      {/* Konten utama dengan lazy load */}
      <Suspense fallback={<LoadingSpinner />}>
        <div id="id-home-container-navbar">
          <Navbar2 />
        </div>

        <div>
          <ImageSlider />
        </div>

        <div>
          <Portofolio />
        </div>

        <div>
          <RekanataContent />
        </div>

        {/*
        <div>
          <HeroCallAction />
        </div>
        */}

        {/*
         <div>
          <PageFlipbookApp/>
        </div>
        */}

        {/*
        <div>
          <ClientsSection />
        </div>
        */}

        {/*
        <div>
          <h1>Ebook Menata Rumah Kecil (Versi Demo)</h1>
          <p>Lihat halaman 1-11 dari ebook kami di bawah ini.</p>

          {demoPages.length > 0 ? (
            <ImageFlipbook pages={demoPages} basePath={basePathForEbooks2025} />
          ) : (
            <p className="error-message">Data halaman demo tidak ditemukan.</p>
          )}
        </div>
        */}

        <div>
          <HeroFreeDesignMasjid reverse />
        </div>

        <div>
          <EbooksApp />
        </div>

        {/*
        <div>
          <FAQ />
        </div>
        */}

        {/*
        <div>
          <HeroCallAction />
        </div>
        */}

        {/*
        <div>
          <OurService />
        </div>
        */}


        <div>
          <FloatingWhatsApp />
        </div>

        <div>
          <Footer />
        </div>
      </Suspense>
    </div>
  );
}

export default Home;
